function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalBarChart = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _reactI18next = require("react-i18next");
var Icons = _interopRequireWildcard(require("../Icons"));
var _STYLES = require("../../styles/STYLES");
var _useLang = require("./useLang");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["items", "style", "barColor", "alreadySorted"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var HorizontalBarChart = exports.HorizontalBarChart = (0, _react.memo)(function (_ref) {
  var items = _ref.items,
    style = _ref.style,
    barColor = _ref.barColor,
    alreadySorted = _ref.alreadySorted,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _items = _useState2[0],
    _setItems = _useState2[1];
  var _STYLES$useStyles = _STYLES.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS;
  (0, _react.useEffect)(function () {
    if (!items) return;
    var _tempItems = JSON.parse(JSON.stringify(items.filter(function (item) {
      return (item == null ? void 0 : item.id) !== 'tree';
    })));
    if (!alreadySorted) {
      _tempItems.sort(function (item1, item2) {
        var _diff = item2.value - item1.value;
        if (_diff !== 0) return _diff;
        if (item1.label.toUpperCase() < item2.label.toUpperCase()) return -1;
        if (item1.label.toUpperCase() > item2.label.toUpperCase()) return 1;
        return 0;
      });
    }
    var largestValue = Math.max.apply(Math, (0, _toConsumableArray2["default"])(_tempItems.map(function (item) {
      return Math.abs(item.value);
    })));
    _tempItems.forEach(function (item) {
      if (item.value === 0) {
        item.width = '0%';
      } else if (!item.width) {
        item.width = "".concat(Math.ceil(Math.abs(item.value) / largestValue * 100), "%");
      }
    });
    var _tree = items.find(function (item) {
      return (item == null ? void 0 : item.id) === 'tree';
    });
    if (_tree && _tree.value < 0) _tempItems.push(_tree);
    _setItems(_tempItems);
  }, [alreadySorted, items]);
  if (!items || items.length === 0) return null;
  return (0, _jsxRuntime.jsx)(_reactNative.View, Object.assign({
    style: [styles.container, style],
    testID: "HorizontalBarChart"
  }, props, {
    children: _items == null ? void 0 : _items.map(function (item, index) {
      var _isNotFirst = index > 0;
      var _isTrees = ((item == null ? void 0 : item.id) && (item == null ? void 0 : item.id) === 'tree' || (item == null ? void 0 : item.id) === 'trees' || (item == null ? void 0 : item.id) === 'forest_conservation' || (item == null ? void 0 : item.id) === 'tree_planting') && Math.abs(item.value) > 0;
      return (0, _jsxRuntime.jsxs)(_reactNative.View, {
        style: styles.item,
        children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
          style: [styles.itemLabel, _isNotFirst && styles.itemLabel_gap],
          numberOfLines: 1,
          ellipsizeMode: "tail",
          children: item.label
        }), _isTrees ? (0, _jsxRuntime.jsxs)(_reactNative.View, {
          style: styles.treeContainer,
          testID: "HorizontalBarChartItemTreeOffset",
          children: [(0, _jsxRuntime.jsx)(Icons.Tree, {
            color: COLORS.goblin
          }), (0, _jsxRuntime.jsxs)(_reactNative.Text, {
            style: styles.treeContainerText,
            children: [t('horiztontalBarChart:treeOffset', {
              value: Math.abs(item.value)
            }), item.unit]
          })]
        }) : (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [(0, _jsxRuntime.jsx)(_reactNative.View, {
            style: styles.itemBarContainer,
            children: (0, _jsxRuntime.jsx)(_reactNative.View, {
              style: [styles.itemBar, {
                width: item.width,
                backgroundColor: barColor ? barColor : COLORS.aubergine
              }],
              testID: "HorizontalBarChartItemBar_".concat(index)
            })
          }), (0, _jsxRuntime.jsxs)(_reactNative.Text, {
            style: styles.itemValue,
            testID: "HorizontalBarChartItemValue_".concat(index),
            children: [t('format:number', {
              value: item.value
            }), item.unit]
          })]
        })]
      }, index);
    })
  }));
});